import React, { Fragment } from 'react'
import { connect } from 'react-redux'

import { ConfirmModal } from 'components/modals'
import EditOrganisation from './forms'
import actions from './actions'

const DialogsBase = ( props ) => {
  return (
    <Fragment>
      <EditOrganisation
        record={props.editModal.record}
        show={props.editModal.open}
        toggle={()=>props.organisationEditModalClose()}
        onChange={props.organisationRecordUpdate}
      />
      <ConfirmModal
        show={props.deleteModal.open}
        title="Confirm Delete Organisation"
        message="Are you sure you want to delete this organisation?"
        onSubmit={()=>props.organisationRecordDelete(props.deleteModal.record)}
        toggle={()=>props.organisationDeleteModalClose()}
      />
    </Fragment>
  )
}

export default connect(
  null,{
  ...actions,
})(DialogsBase);
